import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    standalone: false,
})
export class BannerComponent {
    constructor() {}

    @Input() background = false;
}
